import { Injectable } from '@angular/core';

import { LocationOverviewType, StorageKey } from 'app/models/enums';

@Injectable()
export class StorageService {
  /*
    TODO: use this class for all session- and localstorage functionality.
    TODO: make this a general purpose class (saveObjWithExpiration) and use T
    */

  constructor() {}

  public setLocationOverviewOrigin(type: LocationOverviewType) {
    sessionStorage.setItem(StorageKey.LOCATION_OVERVIEW_ORIGIN_TYPE, type.toString());
  }

  public getLocationOverviewOrigin(): LocationOverviewType {
    const locationOverviewType = sessionStorage.getItem(StorageKey.LOCATION_OVERVIEW_ORIGIN_TYPE);

    if (locationOverviewType && LocationOverviewType[locationOverviewType]) {
      return LocationOverviewType[locationOverviewType];
    } else {
      return LocationOverviewType.LOCATION_OVERVIEW_USER;
    }
  }

  public readLocationListFromStorage(): number[] {
    const storedObj: string = sessionStorage.getItem(StorageKey.LOCATION_LIST_OF_IDS);

    // clear on every read, one-time use
    sessionStorage.removeItem(StorageKey.LOCATION_LIST_OF_IDS);

    if (storedObj) {
      const obj = JSON.parse(storedObj);
      if (new Date().getTime() <= new Date(obj.expiration).getTime()) {
        return obj.list;
      } else {
        return [];
      }
    } else {
      return [];
    }
  }

  public setLocationListInStorage(list: number[]): void {
    const obj = {
      list,
      expiration: new Date(new Date().getTime() + 60 * 1000)
    };
    sessionStorage.setItem(StorageKey.LOCATION_LIST_OF_IDS, JSON.stringify(obj));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/storage.service.ts